import { VDBText } from "@components/atoms";
import useLanguageSelection from "@components/molecules/Languages/LanguageSelector";
import LanguageModal from "@components/molecules/Languages/LanguageModal";
import { useState } from "react";
import { TouchableOpacity } from "react-native";
import { useTheme } from "styled-components/native";

const LanguageSelection = ({ color }: any) => {
  const theme = useTheme();
  const { languages, selectedLanguage, changeLanguage } =
    useLanguageSelection();
  const [isSelectLanguageModalOpen, setIsSelectLanguageModalOpen] =
    useState(false);
  const toggleLanguageModal = () => {
    setIsSelectLanguageModalOpen(!isSelectLanguageModalOpen);
  };

  return (
    <>
      {!!languages?.length && (
        <>
          <TouchableOpacity onPress={toggleLanguageModal}>
            <VDBText color={theme[color] ?? "black"}>
              {selectedLanguage?.title}
            </VDBText>
          </TouchableOpacity>
          <LanguageModal
            isOpen={isSelectLanguageModalOpen}
            onClose={() => setIsSelectLanguageModalOpen(false)}
            languages={languages}
            selectedLanguage={selectedLanguage}
            changeLanguage={changeLanguage}
          />
        </>
      )}
    </>
  );
};

export default LanguageSelection;
